<template>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
          <h1 style="font-size: 10rem;opacity: 0.1;">404</h1>
          <h6 style="position: absolute;background: #EFEFF5;border-radius: 4px;padding: 0px 10px;color: #DADADE;">Page not found</h6>
          <!-- <v-btn style="position: absolute;top: 60%;" color="primary" @click="goHome">Go Home</v-btn> -->
          <div class="home-btn">
            <v-btn type="button" class="AddFlow" outlined block @click="goHome">
              RETURN HOME
            </v-btn>
          </div>
        <!-- <v-row>
          <v-col col="6" style="font-size: 8rem;">
            <h1>Ops Page not found</h1>
          </v-col>
          <v-col col="6">

          </v-col>
        </v-row> -->
        <!-- <v-flex xs12 sm8 md6>
          <v-card>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-0">{{ title }}</h3>
                <div>{{ message }}</div>
              </div>
            </v-card-title>
            <v-card-actions>
              <v-btn color="primary" @click="goHome">Go Home</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex> -->
      </v-layout>
    </v-container>
  </template>
  <script>
  export default {
    props: {
      title: {
        type: String,
        default: 'Error'
      },
      message: {
        type: String,
        default: 'An error occurred'
      }
    },
    methods: {
      goHome() {
        this.$router.push('/')
      }
    }
  }
  </script>
  <style scoped>
  
  .home-btn {
    position: absolute;
    top: 60%;
    margin: 10px;
    border-radius: 8px;
    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2); */
  }
.AddFlow:hover {
  /* background-color: #2c3e50 !important; */
  color: #ffffff !important;
  background-color: #000;
}

.AddFlow {
  height: 100% !important;
  padding: 10px !important;
  border: 3px dotted #000;
}
  </style>